/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 * An object containing fields to update on a user.
 * @export
 * @interface UpdateUserRequestBody
 */
export interface UpdateUserRequestBody {
  /**
   * First name of the user.
   * @type string
   * @memberof UpdateUserRequestBody
   */
  firstName?: string
  /**
   * Last name of the user.
   * @type string
   * @memberof UpdateUserRequestBody
   */
  lastName?: string
  /**
   * The personal email the user registered with.
   * @type string
   * @memberof UpdateUserRequestBody
   */
  username?: string
  /**
   * An official, CC-assigned and managed email address. This cannot be set or changed by most users. Should only be changed by admins or potentially CRs
   * @type string
   * @memberof UpdateUserRequestBody
   */
  email?: string
  /**
   * The phone number associated to the user. It is optional to be set on creation. It can be updated by the user at a late time.
   * @type string
   * @memberof UpdateUserRequestBody
   */
  phone?: string
  /**
   * The user’s country of residence
   * @type string
   * @memberof UpdateUserRequestBody
   */
  countryOfResidence?: string
  /**
   * The user’s country of citizenship
   * @type string
   * @memberof UpdateUserRequestBody
   */
  countryOfCitizenship?: string
}

export function UpdateUserRequestBodyFromJSON(
  json: any
): UpdateUserRequestBody {
  return UpdateUserRequestBodyFromJSONTyped(json, false)
}

export function UpdateUserRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateUserRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    firstName: !exists(json, 'firstName') ? undefined : json['firstName'],
    lastName: !exists(json, 'lastName') ? undefined : json['lastName'],
    username: !exists(json, 'username') ? undefined : json['username'],
    email: !exists(json, 'email') ? undefined : json['email'],
    phone: !exists(json, 'phone') ? undefined : json['phone'],
    countryOfResidence: !exists(json, 'countryOfResidence')
      ? undefined
      : json['countryOfResidence'],
    countryOfCitizenship: !exists(json, 'countryOfCitizenship')
      ? undefined
      : json['countryOfCitizenship'],
  }
}

export function UpdateUserRequestBodyToJSON(
  value?: UpdateUserRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    firstName: value.firstName,
    lastName: value.lastName,
    username: value.username,
    email: value.email,
    phone: value.phone,
    countryOfResidence: value.countryOfResidence,
    countryOfCitizenship: value.countryOfCitizenship,
  }
}
